import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectAuth } from "../../../store/auth_slice";
import Button from "../../button/button";
import apiClient from "../../../services/api_client";

const BillingDataCard: React.FC = () => {
  const { user } = useSelector(selectAuth);
  const [isLoading, setIsLoading] = useState(false);

  const handleStripeAction = async () => {
    setIsLoading(true);
    try {
      if (user?.stripeOnboardingComplete) {
        const { url } = await apiClient.createStripePortalSession();
        window.location.href = url;
      } else {
        const { url } = await apiClient.createStripeAccountLink();
        window.location.href = url;
      }
    } catch {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <div className="flex gap-4 items-center p-4">
        <h3 className="text-lg font-semibold">
          Billing data (mandatory for salers)
        </h3>
        {user?.stripeOnboardingComplete && (
          <span className="text-green-500 flex items-center">
            <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              />
            </svg>
            Verified
          </span>
        )}
      </div>
      <div className="p-4 flex justify-between border-t">
        <Button 
          buttonType="primary" 
          onClick={handleStripeAction} 
          disabled={isLoading}
        >
          {isLoading 
            ? "Processing..." 
            : user?.stripeOnboardingComplete 
            ? "Manage Billing via Stripe" 
            : "Create a Stripe account"}
        </Button>
      </div>
    </div>
  );
};

export default BillingDataCard;
